<script>
import {uniqueId} from 'lodash';

export default {
  name: 'BaseVolanInput',
  inject: {
    volanForm: { default: null }
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: null,
    id: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    required: Boolean,
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean
    },
    dense: { // Ainda não usado
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
    },
  },
  data(vm) {
    return {
      internalId: uniqueId('input_'),
      isFocused: false,
    };
  },
  computed: {
    computedId() {
      return this.id || `input-${this.internalId}`;
    },
    isDisabled() {
      return this.disabled || this.volanForm?.disabled;
    },
    isReadonly() {
      return this.readonly || this.volanForm?.readonly;
    },
    computedLabel() {
      return this.label + (this.required?' *':'');
    },
    hintComputed() {
      return (this.isFocused||this.persistentHint)?(this.hint||''):'';
    }
  },
  methods: {
    onInputFocus() {
      this.isFocused = true;
    },
    onInputBlur() {
      this.isFocused = false;
    }
  }
};
</script>